import {
  formatContainerHeading,
  type AutoNumberPosition,
} from './format-container-heading';

/**
 * Label shown before the em-dash in view/print mode:
 * prefix + autoNumber + schema display suffix (`title` field).
 * Heading text (`node.text`) is rendered separately.
 */
export function formatContainerNameLabel({
  autoNumber,
  prefix,
  displaySuffix,
  numberingStylePosition,
  style,
}: {
  autoNumber: string;
  prefix?: string;
  displaySuffix?: string;
  numberingStylePosition?: AutoNumberPosition | null;
  style: string;
}): string {
  return formatContainerHeading({
    autoNumber,
    prefix,
    suffix: displaySuffix,
    numberingStylePosition,
    style,
    title: '',
  });
}
